













import Vue from 'vue'

export default Vue.extend({
  components: {  },
  props: {
    
  },
  data() {
    return {
      
    }
  },
  computed: {
    
  },
  methods: {

  },
  filters: {

  },
  created() {

  },
  mounted() {

  },
  updated() {

  }
})
